import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router'
    import { ref } from 'vue'
    import { set_login_credentials } from '../module/auth/module';
    import { BACKEND_SERVER } from '../module/common/env';

    // let userSchema = object({
    //     username: string().required(),
    //     password: string().required(),
    // });

    // interface User extends InferType<typeof userSchema> {

    // }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props, { expose: __expose }) {
  __expose();

    let username = ref("")
    let password = ref("")

    let errors = ref("")

    // const valid = computedAsync(
    //     async() => {
    //         let loc_username = username.value
    //         let loc_password = password.value

    //         const loc_user: User = {
    //             username: loc_username,
    //             password: loc_password
    //         }
    //         console.log('valid', loc_user)

    //         try {
    //             await userSchema.validate(loc_user, { strict: true, abortEarly: false },)
    //         } catch (error) {
    //             console.log('error', error.errors)
    //             errors.value = error.errors
    //             return false
    //         }

    //         errors.value = ""
    //         return true
    //     },
    //     false
    // )

    const router = useRouter()

    async function login(user) {
        let loc_login_response = await fetch(BACKEND_SERVER + '/login', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({"Username": user.username, "Password": user.password})
        })
        
        if (loc_login_response.status === 200) {
            let loc_json = await loc_login_response.json()
            set_login_credentials(loc_json.SessionKey)
            errors.value = ""
            router.push("/")
        } else {
            errors.value = "Invalid username or password"
        }

        // console.log('user', await asdf.json(), asdf.status)
    }


const __returned__ = { get username() { return username }, set username(v) { username = v }, get password() { return password }, set password(v) { password = v }, get errors() { return errors }, set errors(v) { errors = v }, router, login }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})